import type { FaireProductEntity } from "../../entity_types/product";

export const p_5pq86hmwdz: FaireProductEntity = {
  token: "p_5pq86hmwdz",
  type: "product",
  name: "(SET OF 7)PEBBLES - CHAKRA PLAIN (SET OF 7) 25 MM",
  brandToken: "b_b1k03395mh",
  brandName: "Oceanic Linkways Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/b58ec1720954dc3bc9e5952ef17f3647b1c97679949945708b76641b32cbf58d.jpeg",
  galleryImageUrls: [],
  priceDollars: 15.38,
  description:
    "Our set of 7, 25mm Chakra Plain Pebbles is an essential addition to your spiritual wellness routine. Each pebble is carefully selected and polished to ensure quality and consistency. The set is ideal for meditation, yoga, or any spiritual practice. As a premier wholesaler of gemstones and spiritual gifts, Oceanic Linkways is committed to providing high-quality products. Enhance your spiritual journey with our Chakra Plain Pebbles.",
  tags: [],
  msrpDollars: 61.52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:10.868Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
